"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RemoteImage", {
  enumerable: true,
  get: function get() {
    return _RemoteImage.RemoteImage;
  }
});
Object.defineProperty(exports, "ImageUtil", {
  enumerable: true,
  get: function get() {
    return _ImageUtil.ImageUtil;
  }
});
Object.defineProperty(exports, "ImageResource", {
  enumerable: true,
  get: function get() {
    return _ImageResource.ImageResource;
  }
});
Object.defineProperty(exports, "ManagedImage", {
  enumerable: true,
  get: function get() {
    return _ManagedImage.ManagedImage;
  }
});
Object.defineProperty(exports, "LocalImage", {
  enumerable: true,
  get: function get() {
    return _LocalImage.LocalImage;
  }
});
Object.defineProperty(exports, "SparkelloImage", {
  enumerable: true,
  get: function get() {
    return _SparkelloImage.SparkelloImage;
  }
});
Object.defineProperty(exports, "DefaultPhotos", {
  enumerable: true,
  get: function get() {
    return _DefaultPhotos.DefaultPhotos;
  }
});
exports.defaultDreamImage = void 0;

var _RemoteImage = require("./RemoteImage");

var _ImageUtil = require("./ImageUtil");

var _ImageResource = require("./ImageResource");

var _ManagedImage = require("./ManagedImage");

var _LocalImage = require("./LocalImage");

var _SparkelloImage = require("./SparkelloImage");

var _DefaultPhotos = require("./DefaultPhotos");

var defaultDreamImage = new _RemoteImage.RemoteImage({
  uri: 'https://images.unsplash.com/photo-1495539406979-bf61750d38ad?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjExMDA3OX0'
});
exports.defaultDreamImage = defaultDreamImage;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbWFnZS9pbmRleC50cyJdLCJuYW1lcyI6WyJkZWZhdWx0RHJlYW1JbWFnZSIsIlJlbW90ZUltYWdlIiwidXJpIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0E7O0FBRUE7O0FBQ0E7O0FBRUE7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBRU8sSUFBTUEsaUJBQWdDLEdBQUcsSUFBSUMsd0JBQUosQ0FBZ0I7QUFDNURDLEVBQUFBLEdBQUcsRUFBRTtBQUR1RCxDQUFoQixDQUF6QyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEltYWdlUmVzb3VyY2UgfSBmcm9tICcuL0ltYWdlUmVzb3VyY2UnO1xuaW1wb3J0IHsgUmVtb3RlSW1hZ2UgfSBmcm9tICcuL1JlbW90ZUltYWdlJztcblxuZXhwb3J0IHtJbWFnZVV0aWx9IGZyb20gJy4vSW1hZ2VVdGlsJztcbmV4cG9ydCB7SW1hZ2VSZXNvdXJjZX0gZnJvbSBcIi4vSW1hZ2VSZXNvdXJjZVwiO1xuZXhwb3J0IHtSZW1vdGVJbWFnZX0gZnJvbSBcIi4vUmVtb3RlSW1hZ2VcIjtcbmV4cG9ydCB7TWFuYWdlZEltYWdlfSBmcm9tIFwiLi9NYW5hZ2VkSW1hZ2VcIjtcbmV4cG9ydCB7TG9jYWxJbWFnZX0gZnJvbSBcIi4vTG9jYWxJbWFnZVwiO1xuZXhwb3J0IHtTcGFya2VsbG9JbWFnZX0gZnJvbSAnLi9TcGFya2VsbG9JbWFnZSdcbmV4cG9ydCB7RGVmYXVsdFBob3Rvc30gZnJvbSBcIi4vRGVmYXVsdFBob3Rvc1wiO1xuXG5leHBvcnQgY29uc3QgZGVmYXVsdERyZWFtSW1hZ2U6IEltYWdlUmVzb3VyY2UgPSBuZXcgUmVtb3RlSW1hZ2Uoe1xuICAgIHVyaTogJ2h0dHBzOi8vaW1hZ2VzLnVuc3BsYXNoLmNvbS9waG90by0xNDk1NTM5NDA2OTc5LWJmNjE3NTBkMzhhZD9peGxpYj1yYi0xLjIuMSZxPTgwJmZtPWpwZyZjcm9wPWVudHJvcHkmY3M9dGlueXNyZ2Imdz00MDAmZml0PW1heCZpeGlkPWV5SmhjSEJmYVdRaU9qRXhNREEzT1gwJyxcbiAgfSxcbik7XG4iXX0=